import Button from 'carbon-react/lib/components/button';
import Dialog from 'carbon-react/lib/components/dialog';
import { type FormEventHandler, useState } from 'react';
import { send } from '../../../helpers/requests';

export interface ReactivateCompanyButtonProps {
  intacctCompanyId: string;
  adminUsername: string;
  adminEmail: string;
}

export function ReactivateCompanyButton({
  adminEmail,
  adminUsername,
  intacctCompanyId,
}: ReactivateCompanyButtonProps) {
  const [requestSuccess, setRequestSuccess] = useState<boolean | null>(null);
  const handleSubmit: FormEventHandler<Element> = async (e) => {
    e.preventDefault();
    try {
      setRequestSuccess(false);
      await send({
        method: 'POST',
        url: '/admin/unarchive-company',
        data: {
          intacctCompanyId: intacctCompanyId,
          username: adminUsername,
          email: adminEmail,
        },
        credentials: 'include',
      });
      setRequestSuccess(true);
    } catch (error) {
      setRequestSuccess(false);
    }
  };

  const closeModal = () => setRequestSuccess(false);

  // TODO: Move the dialog to a separate component because it leaks when switching between tabs
  return (
    <>
      <Button buttonType="primary" onClick={handleSubmit} ml={2}>
        Reactivate
      </Button>
      <Dialog onCancel={closeModal} title="Success" open={!!requestSuccess}>
        <div>
          <span>
            You've successfully reactivated <strong>{intacctCompanyId}</strong>
            's Sage Intelligent Time account.
          </span>
        </div>
        <div className="intacct-admin-modal-footer">
          <Button buttonType="primary" onClick={closeModal}>
            OK
          </Button>
        </div>
      </Dialog>
    </>
  );
}
